module.exports = __webpack_public_path__ + "static/media/EPR.adbc0cb0.svg";